// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"ed6de562","307":"131ee2f9","417":"5c63f0c8","453":"fb8decbc","476":"685e8b9b","563":"e523ec81","692":"c1218fea","720":"0c172495","839":"3ed7bc2f","844":"d635190d","886":"392bc3ba","896":"dbd1464c","971":"31649e42"}[chunkId] + ".chunk.js";
};